import React from 'react';

import Card from 'buyside/components/presentation/Card/card';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import Post from 'buyside/components/presentation/PostShow/postShow';
import PostComments from 'buyside/components/presentation/PostShow/postComments';
import PostRelatedResearch from 'buyside/components/presentation/PostShow/postRelatedResearch';

import styles from './postShowStyles.scss';

const PostShowContainer: React.FC<{ postId: string }> = ({ postId }): React.ReactElement => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.leftContainer}>
        <Card>
          <ErrorBoundary pageName="the post details">
            <Post postId={postId} />
          </ErrorBoundary>
        </Card>
        <Card>
          <ErrorBoundary pageName="the post comments">
            <PostComments postId={postId} />
          </ErrorBoundary>
        </Card>
      </div>
      <Card>
        <ErrorBoundary pageName="the post related research">
          <PostRelatedResearch postId={postId} />
        </ErrorBoundary>
      </Card>
    </div>
  );
};

export default PostShowContainer;
